import { show } from 'redux-modal'
import { PROMOTIONS_DETAIL_MODAL_PAGE } from 'constant'

const PROMOTIONS_DETAIL_PAGE_LINK = '/deal?promotionId='

export const showPromotionsDetailModalPage = promoId =>
  promoId && show(PROMOTIONS_DETAIL_MODAL_PAGE, { pageSrc: PROMOTIONS_DETAIL_PAGE_LINK + promoId })
